import React from "react";
import { useTranslation } from "react-i18next";

const ContactIntro = () => {
  const { t } = useTranslation();
  return (
    <>
      <header
        data-w-id="836d87a6-33ac-1128-12b5-5b3710539e86"
        className="section _60 con"
      >
        <div className="container hero-center">
          <h1 className="heading-9vw">{t("contact.intro.heading")}</h1>
        </div>
      </header>
      <section className="section topless bottom-10">
        <div
          data-w-id="010d51b9-9151-82fd-bfd8-6c2e1374a5ac"
          className="container"
        >
          <div className="full-wrap conta">
            <div className="paragraph-wrap _65">
              <div className="pad-15">
                <h3 className="heading-38">
                  {t("contact.intro.subheading")}
                </h3>
              </div>
              <p className="body-16">{t("contact.intro.paragraph1")}</p>
              <p className="body-16">{t("contact.intro.paragraph2")}</p>
              <p className="body-16">{t("contact.intro.paragraph3")}</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactIntro;
